export default __webpack_public_path__ + "static/media/magkey-logo.ed505db6.png";